import { useContext, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import { userGroupsContext, userGroupSchema } from "../UserGroupsContext";
import { EditIconButton, AddNewButton } from "components";


let UserGroupEditor = ({ id }: { id?: string }) => {
    let service = useContext(userGroupsContext);

    let [isOpen, setOpen] = useState(false);


    useEffect(() => {
        if (isOpen === true)
            service.getUserGroup(id);
    }, [isOpen, id])

    return (
        <>
            {id === undefined && <AddNewButton onClick={() => setOpen(true)} />}
            {id !== undefined && <EditIconButton onClick={() => setOpen(true)} />}

            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle>{id === undefined ? 'Nuovo' : 'Modifica'} gruppo</DialogTitle>
                <Formik
                    enableReinitialize={true}
                    initialValues={service.userGroup}
                    validationSchema={userGroupSchema}
                    onSubmit={async (values) => {
                        let res = await service.saveUserGroup(values);
                        if (res === true)
                            setOpen(false);
                    }}
                >
                    <Form>
                        <DialogContent>

                            <Grid>
                                <Field
                                    component={TextField}
                                    name="key"
                                    label="Codice"
                                    disabled={id !== undefined}
                                    margin="normal"
                                />
                                <Field
                                    component={TextField}
                                    name="description"
                                    label="Descrizione"
                                    margin="normal"
                                />
                            </Grid>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpen(false)} color="secondary">Chiudi</Button>
                            <Button type="submit">Salva</Button>
                        </DialogActions>
                    </Form>
                </Formik>
            </Dialog>
        </>
    )
}

export default UserGroupEditor;